import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { createConnection } from "common/utils/createSignalR"
import {
  setCertificadoValidation,
  setShowModalEmpresaCertificado,
  setShowModalInvalidCertificado,
} from "features/Validaciones/redux/slices/validationsSlice"
import { useDispatch } from "hooks/useDispatch"
import { useEffect, useState } from "react"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let connectionCertificationHub: $TSMigrationFixMe

const useRealTimeCerficiation = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [isOn, setIsOn] = useState(false)
  const { activeCompany } = useUsuarioEmpresaActiva()

  // @ts-expect-error TS(7030): Not all code paths return a value.
  useEffect(() => {
    if (open) {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(async () => {
        connectionCertificationHub = createConnection({
          hub: "SignalR/CertificationHub",
          baseURL: import.meta.env.REACT_APP_CERTIFICADOS,
        })

        connectionCertificationHub
          .start()
          .then(() => setIsOn(true))
          .catch(() => {
            dispatch(setShowModalEmpresaCertificado(true))
            setIsOn(false)
          })

        await Promise.all([connectionCertificationHub])
      })()

      return () => {
        open && connectionCertificationHub?.stop()
        setIsOn(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  useEffect(() => {
    if (open) {
      connectionCertificationHub?.on(
        "CheckCertificate",
        async ({ isValid, nif }: { isValid?: boolean; nif?: string }) => {
          if (isValid && nif === activeCompany.nif) {
            dispatch(setCertificadoValidation(true))
          } else {
            dispatch(setCertificadoValidation(false))
            dispatch(setShowModalInvalidCertificado(true))
          }
          connectionCertificationHub?.stop()
          setIsOn(false)
          setOpen(false)
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, dispatch])

  return {
    setOpen,
    isOn,
  }
}

export default useRealTimeCerficiation
